import {
    ExchangeConfigActionEnum,
    IFetchExchangeConfigAction,
    IFetchExchangeConfigSuccessAction,
    IFetchExchangeConfigFailedAction,
  IPostExchangeConfigAction,
  IPostExchangeConfigSuccessAction,
IPostExchangeConfigFailedAction
} from '.';
import {
    IExchangeConfig,
} from '../../services';

export const FetchExchangeConfigAction = () => {
    return {
        type: ExchangeConfigActionEnum.FetchExchangeConfig,
        state: { loading: true },
    } as IFetchExchangeConfigAction;
};

export const FetchExchangeConfigSuccessAction = (exchangeConfigs: IExchangeConfig[]) => {
    return {
        type: ExchangeConfigActionEnum.FetchExchangeConfigSuccess,
        state: { loading: false, exchangeConfigs: exchangeConfigs },
    } as IFetchExchangeConfigSuccessAction;
};

export const FetchExchangeConfigFailedAction = (message: string) => {
    return {
      type: ExchangeConfigActionEnum.FetchExchangeConfigFailed,
      state: { loading: false, exceptionMessage: message },
    } as IFetchExchangeConfigFailedAction;
};


export const PostExchangeConfigAction = (exchangeConfig: IExchangeConfig) => {
  return {
    type: ExchangeConfigActionEnum.PostExchangeConfig,
    state: { loading: true, exchangeConfig: exchangeConfig },   
  } as IPostExchangeConfigAction;
};

export const PostExchangeConfigSuccessAction = () => {
  return {
    type: ExchangeConfigActionEnum.PostExchangeConfigSuccess,
    state: { loading: false},
  } as IPostExchangeConfigSuccessAction;
};

export const PostExchangeConfigFailedAction = (message: string) => {
  return {
    type: ExchangeConfigActionEnum.PostExchangeConfigFailed,
    state: { loading: false, exceptionMessage: message },
  } as IPostExchangeConfigFailedAction;
};
